import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash';
import constants from '../config/constant';
import { API, AUTH } from '../store'
import store from '../store'
import { getUser } from '../actions/users'
import { loginSuccess } from '../actions/authentication'

export default ({ component: C, props: cProps, ...rest }) => {
  
  const { BUYER_URL, ROLE, REDIRECT_URL, ADMIN_URL, ORG_URL } = constants;
  return (
    <Route
      {...rest}
      render={props => {
        if (!isEmpty(cProps.authentication.authenticatedUser)) {
          const { role } = cProps.authentication.authenticatedUser;
          if ((role && ((role === ROLE['BUYER'] && BUYER_URL.includes(props.match.path)) || (role === ROLE['ADMIN'] && ADMIN_URL.includes(props.match.path)) || (role === ROLE['ORGANISATION'] && ORG_URL.includes(props.match.path)))) || (role === ROLE['CONTACT']) || ((!role || role === ROLE['REALTOR']) && !BUYER_URL.includes(props.match.path))) {
            return <C {...props} {...cProps} />;
          } else {
            let redirectUrl = '';
            switch (role) {
              case ROLE['USER']:
                redirectUrl = REDIRECT_URL['EMERGENCY_CONTACT'];
                break;
              case ROLE['BUYER']:
                redirectUrl = REDIRECT_URL['BUYER_PROFILE'];
                break;
              case ROLE['ADMIN']:
                redirectUrl = REDIRECT_URL['ADMIN'];
                break;
              case ROLE['ORGANISATION']:
                redirectUrl = REDIRECT_URL['ORGANISATION_DASHBOARD'];
                break;
              default:
                redirectUrl = REDIRECT_URL['EMERGENCY_CONTACT'];
            }

              return (
                <Redirect
                  to={{
                    // pathname: !role || role === ROLE['REALTOR'] ? REDIRECT_URL['EMERGENCY_CONTACT'] : REDIRECT_URL['BUYER_PROFILE'],
                    pathname: redirectUrl,
                    state: {
                      redirect: `${props.location.pathname}${props.location.search}`
                    }
                  }}
                />
              );
          }
        }  else if (props.location.pathname === '/showings' && props.location.search !== '' ) {
          var data = (props.location.search).split('=')
          if(data[0] === '?auth' && data[1] === '1&token'){
          var newToken = data[2].split('&')
          API.set('Authorization', newToken[0])
          AUTH.set('Authorization', newToken[0])
          store.dispatch(getUser(Number(data[3]), true))
            .then(getUserResponse => {
              store.dispatch(loginSuccess(getUserResponse, newToken[0]))
            })
          return (
            <C {...props} {...cProps} />
          );
          } else {
            return(
            <Redirect
              to={{
                pathname: REDIRECT_URL['LOGIN']
              }}
            />
            )
          }
        } else {
          let redirectUrl = REDIRECT_URL['LOGIN'];
          if (ORG_URL.includes(props.match.path) || ADMIN_URL.includes(props.match.path)) {
            redirectUrl = REDIRECT_URL['ORGANISATION']
          }
          return (
            <Redirect
              to={{
                pathname: redirectUrl,
                state: {
                  redirect: `${props.location.pathname}${props.location.search}`
                }
              }}
            />
          );
        }
      }}
    />
  );
};
